<template>
  <div class="pl-4 ">
    <b-row>
      <b-col style="display:none">
        <b-form-checkbox v-model="checkActiva" >
          <p style="font-size:10px;color:gray !important">
            Activa
          </p>
        </b-form-checkbox></b-col
      >
    </b-row>
    <br>
    <div style="display:flex">
      <h4>Grupos</h4>

      <b-button
        v-if="USER().rol == ROLES.SUPER"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        class="btn-icon ml-1"
        style="margin-top:-8px"
        size="sm"
        @click="addGrupo"
      >
        <feather-icon size="22" icon="PlusCircleIcon" />
      </b-button>
    </div>
    <div v-for="item in dataEtapa.grupos" :key="item.id_grupo">
      <item-grupo :dataGrupo="item"></item-grupo>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { ref, watch } from '@vue/composition-api'
import {
  BRow,
  BCol,
  BFormCheckbox,
  // BFormInput,
  BButton,
  //   BFormGroup,
  // xx
} from 'bootstrap-vue'
import {
  // URL,
  USER,
  ROLES,
  // xx
} from '../../utils/variables'
import itemGrupo from './ItemGrupo.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormCheckbox,
    // BFormInput,
    BButton,
    itemGrupo,
    // BFormGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    dataEtapa: Object,
  },
  setup(props) {
    // eslint-disable-next-line
    const checkActiva = ref(props.dataEtapa.estado === 'a' ? true : false)

    function addGrupo() {
      const itemGrupoAdd = {
        nombreGrupo: `Grupo ${props.dataEtapa.grupos.length + 1}`,
        estado_fixture: 'generar',
        grupo: props.dataEtapa.grupos.length + 1,
        estado: 'a',
        id_modalidad_grupo: null,
        id_modalidad: props.dataEtapa.id_modalidad,
      }
      props.dataEtapa.grupos.push(itemGrupoAdd)
    }
    watch(checkActiva, despues => {
      if (despues) {
        props.dataEtapa.estado = 'a'
      } else {
        props.dataEtapa.estado = 'd'
      }
    })

    return {
      checkActiva,
      addGrupo,
      USER,
      ROLES,
    }
  },
}
</script>

<style></style>
